import axios from 'axios';
import { toast } from 'react-toastify';
import envVariables from '../../../config';
let globalErrorLimit = 1;
let counter = 0



const apiCall = async (envUrl, type, body = {}, showToast = true) => {
  try {
    if (!type || !envUrl) {
      return false;
    }

    const token = window.localStorage.getItem("token");
    const isFileUpload = body instanceof FormData; // Check if body is FormData

    const config = {
      url: envVariables[envUrl],
      method: type,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": isFileUpload ? "multipart/form-data" : "application/json", // Set appropriate Content-Type
      },
      data: body,
    };

    const { data } = await axios(config);
    if (!data) {
      return false;
    }
    return data;
  } catch (error) {
    console.error("apiCall Error ::", error);
    return (error.response) ? error.response.data : false;
  }
};

export default apiCall;